import { ARTIST_SECTION } from '../../constants/gaEnums';
export const artistSections = [
  ['fullAlbums', 'full-albums', '앨범', 'Albums'],
  ['singles', 'singles', '싱글 및 EP', 'Singles & EPs'],
  ['liveAlbums', 'live-albums', '라이브 앨범', 'Live Albums'],
  ['compilationAlbums', 'compilation-albums', '컴필레이션 앨범', 'Compilation Albums'],
  ['appearsOnAlbums', 'appears-on-albums', '피처링', 'Appears On'],
  ['includedPlaylists', 'included-playlists', '포함된 플레이리스트', 'Featured in Playlists'],
  ['similarArtists', 'similar-artists', '유사한 아티스트', 'Similar Artists'],
];
export function artistIdentity(params, search, state) {
  const sourceId = params.sourceId || search.get('source_id') || state?.sourceId || undefined;
  const sourceType =
    params.artistSource ||
    search.get('source_type') ||
    state?.sourceType ||
    (sourceId ? 'APPLE_MUSIC' : undefined);
  return { slug: params.artistSlug, sourceId, sourceType };
}
export function artistPath(artist) {
  const id = artist.sourceId ?? artist.id;
  const source = (artist.artistSource || 'APPLE_MUSIC').toLowerCase();
  if (artist.slug)
    return `/artists/${encodeURIComponent(artist.slug)}${id ? `?${new URLSearchParams({ source_id: id, source_type: source })}` : ''}`;
  return `/artists/${source}/${encodeURIComponent(id)}`;
}
export function artistViewPath(artist, view) {
  if (artist.slug)
    return `/artists/${encodeURIComponent(artist.slug)}/view/${view}?${new URLSearchParams({ source_id: artist.sourceId, source_type: artist.artistSource.toLowerCase(), artistName: artist.name })}`;
  return `/artists/${artist.artistSource.toLowerCase()}/${encodeURIComponent(artist.sourceId)}/${view}?${new URLSearchParams({ artistName: artist.name })}`;
}

export const artistSectionTracking = {
  'full-albums': ARTIST_SECTION.FULL_ALBUMS,
  singles: ARTIST_SECTION.SINGLES,
  'live-albums': ARTIST_SECTION.LIVE_ALBUMS,
  'compilation-albums': ARTIST_SECTION.COMPILATION_ALBUMS,
  'appears-on-albums': ARTIST_SECTION.APPEARS_ON,
  'included-playlists': 'included_playlists',
  'similar-artists': ARTIST_SECTION.SIMILAR_ARTISTS,
};
